import Icon from '@ant-design/icons';
import * as React from 'react';

const FieldResourcesSvg = () => {
  return (
    <svg
      width={18}
      height={16}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.112 8.333l.388-4M11.888 8.333l-.388-4"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M7.167 2.333h3.666c.368 0 .667.298.667.667v1.333h-5V3c0-.369.298-.667.667-.667zM5.5 8.833a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5v-4z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 10.833h2"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M10.5 8.833a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-4z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 10.833h2M7.5 9.833h3M5.5 8.833h-4M16.5 8.833h-4M2.75 10.833a.25.25 0 01.25.25M2.5 11.083a.25.25 0 01.25-.25M2.75 11.333a.25.25 0 01-.25-.25M3 11.083a.25.25 0 01-.25.25M2.75 12.833a.25.25 0 01.25.25M2.5 13.083a.25.25 0 01.25-.25M2.75 13.333a.25.25 0 01-.25-.25M3 13.083a.25.25 0 01-.25.25M15.25 10.833a.25.25 0 01.25.25M15 11.083a.25.25 0 01.25-.25M15.25 11.333a.25.25 0 01-.25-.25M15.5 11.083a.25.25 0 01-.25.25M15.25 12.833a.25.25 0 01.25.25M15 13.083a.25.25 0 01.25-.25M15.25 13.333a.25.25 0 01-.25-.25M15.5 13.083a.25.25 0 01-.25.25"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const FieldResourcesIcon = (props: any) => (
  <Icon component={FieldResourcesSvg} {...props} />
);

export default FieldResourcesIcon;
